import React, { useEffect, useMemo, useState } from 'react';
import TitleComponent from '../Title/TitleComponent.jsx';
import { Box, Button, Pagination, Typography, useMediaQuery, FormGroup, FormControlLabel, Checkbox, Fab } from '@mui/material';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import ProductCard from './ProductCard.jsx';
import CommonButtonComponent from '../Button/CommonButtonComponent.jsx';
import ProductSearchBar from '../Search/ProductSearchBar.jsx';
import { sortProductsBySerialOrCreatedDate } from '../../service/ProductSortService.js';

function UserHomeProductCardComponent({
  title,
  data,
  type,
  history,
  showViewAll = true,
  showPrice = true,
  searchAlign = "center",
}) {
  const [openFilter, setOpenFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [visitedPages, setVisitedPages] = useState([1]);
  const isMobile = useMediaQuery("(max-width:600px)");
  const itemsPerPage = isMobile ? 4 : 9;
  const normalizedSearch = searchTerm.trim().toLowerCase();
  const isSearching = normalizedSearch.length > 0;
  const sortedSourceData = useMemo(
    () => sortProductsBySerialOrCreatedDate(data),
    [data]
  );
  const filteredData = useMemo(() => {
    if (!Array.isArray(sortedSourceData)) {
      return [];
    }

    if (!normalizedSearch) {
      return sortedSourceData;
    }

    return sortedSourceData.filter((item) => {
      const searchFields = [
        item?.productTitle,
        item?.productCode,
        item?.category,
        item?.marketingCategory,
        item?.otherData?.name,
      ];

      return searchFields.some((field) =>
        String(field || "").toLowerCase().includes(normalizedSearch)
      );
    });
  }, [normalizedSearch, sortedSourceData]);
  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [currentPage, filteredData, itemsPerPage]);
  const paginatedOriginalData = useMemo(() => {
    const source = Array.isArray(sortedSourceData) ? sortedSourceData : [];
    return visitedPages.map((page) => {
      const startIndex = (page - 1) * itemsPerPage;
      return {
        page,
        items: source.slice(startIndex, startIndex + itemsPerPage),
      };
    });
  }, [itemsPerPage, sortedSourceData, visitedPages]);

  useEffect(() => {
    setVisitedPages((prev) =>
      prev.includes(currentPage) ? prev : [...prev, currentPage]
    );
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    setVisitedPages([1]);
  }, [title, data, itemsPerPage]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "20px",
        width: "100%",
      }}
    >
      {/* Main Container */}
      <Box
        sx={{
          width: isMobile ? "95%" : "1000px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          paddingLeft: openFilter && !isMobile ? "250px" : "",
          transition: "padding-left 0.3s ease-in-out",
        }}
      >
        {type === "catagories" && (
          <>
            {!isMobile ? (
              // Desktop Filter
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Button
                  variant="text"
                  sx={{
                    textTransform: "capitalize",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    color: "#000000",
                    fontSize: "19px",
                    fontFamily:
                      "'Amiko',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                  }}
                  onClick={() => setOpenFilter(!openFilter)}
                >
                  <TuneRoundedIcon />
                  Filter
                </Button>
                {openFilter && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50px",
                      left: 0,
                      width: "200px",
                      height: "auto",

                      transform: openFilter ? "scaleY(1)" : "scaleY(0)",
                      transformOrigin: "top",
                      opacity: openFilter ? 1 : 0,
                      transition:
                        "transform 1s ease-in-out 1s, opacity 1s ease-out 0.3s",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        fontFamily:
                          "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                      }}
                    >
                      Size
                    </p>
                    <FormGroup
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "0.5fr 1fr",
                        width: "300px",
                      }}
                    >
                      <FormControlLabel control={<Checkbox />} label="XS" />
                      <FormControlLabel control={<Checkbox />} label="L" />
                      <FormControlLabel control={<Checkbox />} label="S" />
                      <FormControlLabel control={<Checkbox />} label="XL" />
                      <FormControlLabel control={<Checkbox />} label="M" />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Free Size"
                      />
                    </FormGroup>

                    <p
                      style={{
                        fontSize: "20px",
                        fontFamily:
                          "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                      }}
                    >
                      Price Range
                    </p>
                    <FormGroup
                      sx={{
                        width: "300px",
                      }}
                    >
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Below 10,000 MMK "
                      />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="10,000 MMK - 20,000 MMK"
                      />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Above 20,000 MMK"
                      />
                    </FormGroup>

                    <p
                      style={{
                        fontSize: "20px",
                        fontFamily:
                          "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                      }}
                    >
                      Fabric / Material
                    </p>
                    <FormGroup
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "0.5fr 1fr",
                        width: "300px",
                      }}
                    >
                      <FormControlLabel control={<Checkbox />} label="Cotton" />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Polyester"
                      />
                      <FormControlLabel control={<Checkbox />} label="Silk" />
                      <FormControlLabel control={<Checkbox />} label="Linen" />
                      <FormControlLabel control={<Checkbox />} label="Satin" />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Wool / Blends"
                      />
                      <FormControlLabel control={<Checkbox />} label="Denim" />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Faux Leather"
                      />
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Chiffon"
                      />
                      <FormControlLabel control={<Checkbox />} label="Lace" />
                    </FormGroup>
                  </Box>
                )}
              </Box>
            ) : (
              // Mobile Filter - FAB Button and Slide-In Panel
              <>
                <Fab
                  color="primary"
                  aria-label="filter"
                  sx={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 1100,

                    color: "#fff",
                  }}
                  onClick={() => setOpenFilter(!openFilter)}
                >
                  <TuneRoundedIcon />
                </Fab>

                {/* Sliding Filter Panel */}
                <Box
                  sx={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100%",
                    width: "250px",
                    backgroundColor: "#ffffff",
                    boxShadow: "-2px 0 5px rgba(0,0,0,0.2)",
                    transform: openFilter
                      ? "translateX(0)"
                      : "translateX(100%)",
                    transition: "transform 0.3s ease-in-out",
                    zIndex: 1000,
                    paddingTop: "150px",
                    padding: "100px 0 0 25px",
                    overflow: "scroll",
                  }}
                >
                  <p
                    style={{
                      fontSize: isMobile ? "16px" : "20px", // Reduce font size for mobile
                      fontFamily:
                        "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                    }}
                  >
                    Size
                  </p>
                  <FormGroup
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "0.5fr 1fr",
                      width: "300px",
                    }}
                  >
                    <FormControlLabel control={<Checkbox />} label="XS" />
                    <FormControlLabel control={<Checkbox />} label="L" />
                    <FormControlLabel control={<Checkbox />} label="S" />
                    <FormControlLabel control={<Checkbox />} label="XL" />
                    <FormControlLabel control={<Checkbox />} label="M" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Free Size"
                    />
                  </FormGroup>

                  <p
                    style={{
                      fontSize: isMobile ? "16px" : "20px", // Reduce font size for mobile
                      fontFamily:
                        "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                    }}
                  >
                    Price Range
                  </p>
                  <FormGroup
                    sx={{
                      width: "300px",
                    }}
                  >
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Below 10,000 MMK "
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="10,000 MMK - 20,000 MMK"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Above 20,000 MMK"
                    />
                  </FormGroup>

                  <p
                    style={{
                      fontSize: isMobile ? "16px" : "20px", // Reduce font size for mobile
                      fontFamily:
                        "'Anek Malayalam',Inter', 'Segoe UI', 'Oxygen', 'Ubuntu', sans-serif",
                    }}
                  >
                    Fabric / Material
                  </p>
                  <FormGroup
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "0.5fr 1fr",
                      width: "300px",
                    }}
                  >
                    <FormControlLabel control={<Checkbox />} label="Cotton" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Polyester"
                    />
                    <FormControlLabel control={<Checkbox />} label="Silk" />
                    <FormControlLabel control={<Checkbox />} label="Linen" />
                    <FormControlLabel control={<Checkbox />} label="Satin" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Wool / Blends"
                    />
                    <FormControlLabel control={<Checkbox />} label="Denim" />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Faux Leather"
                    />
                    <FormControlLabel control={<Checkbox />} label="Chiffon" />
                    <FormControlLabel control={<Checkbox />} label="Lace" />
                  </FormGroup>
                </Box>
              </>
            )}
          </>
        )}
        {title ? <TitleComponent Title={title} /> : null}
      </Box>

      <ProductSearchBar
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
        align={searchAlign}
      />

      {/* Product Cards */}
      <Box
        sx={{
          display: "grid",
          width: isMobile ? "95%" : "1000px",
          gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
          gap: isMobile ? "18px" : "28px",
          justifyItems: "center",
          marginTop: "20px",
          marginLeft: openFilter && !isMobile ? "250px" : "",
          transition: "margin-left 0.3s ease-in-out",
        }}
      >
        {isSearching ? (
          <ProductCard
            data={paginatedData}
            type={type}
            history={history}
            showPrice={showPrice}
          />
        ) : (
          paginatedOriginalData.map(({ page, items }) => (
            <Box
              key={`page-cache-${page}`}
              sx={{ display: currentPage === page ? "contents" : "none" }}
            >
              <ProductCard
                data={items}
                type={type}
                history={history}
                showPrice={showPrice}
              />
            </Box>
          ))
        )}
      </Box>

      {Array.isArray(data) && data.length > 0 && filteredData.length === 0 && (
        <Typography
          sx={{
            marginTop: "20px",
            textAlign: "center",
            fontSize: isMobile ? "14px" : "16px",
            color: "#6F6F6F",
            fontWeight: 500,
          }}
        >
          No matching products found.
        </Typography>
      )}

      {filteredData.length > itemsPerPage && (
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(_, value) => setCurrentPage(value)}
          color="standard"
          shape="rounded"
          sx={{
            marginTop: "28px",
            "& .MuiPaginationItem-root": {
              fontWeight: 600,
              borderRadius: "10px",
            },
            "& .Mui-selected": {
              backgroundColor: "#111111 !important",
              color: "#FFFFFF",
            },
          }}
        />
      )}

      {showViewAll && (
        <CommonButtonComponent
          children={"View All"}
          sx={{
            borderRadius: "6px",
            width: "100px",
            marginTop: "24px",
          }}
          onClick={() => {
            history.push({
              pathname: "categoriesDetail",
              state: { title: title }, 
            });          
          }}
        />
      )}
    </Box>
  );
}

export default UserHomeProductCardComponent;
